module.exports = __webpack_public_path__ + "static/img/bg7.ff94468.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg7.jpg
// module id = QEHO
// module chunks = 1